import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { apiExportJobs, apiGetJobsList, apiMarkInvoiced, apiMergeJobs, apiSearchJobs, apiDeleteJob, apiRenameJob } from "../async/jobAsync";
import { ExportJobsCommand, GetJobsListQuery, GetJobsListResponse, Job, MarkInvoicedCommand, MarkInvoicedResponse, MergeJobsCommand, MergeJobsResponse, RenameJobCommand, SearchJobsRequest, SearchJobsResponse } from "../model/jobModel";

export const clearCreatedJob = createAction("job/CLEAR_CREATED_JOB");

export const searchJobs = createAsyncThunk<SearchJobsResponse, SearchJobsRequest, {state: RootState, rejectValue: string}>("job/SEARCH_JOBS", async(payload, { getState, rejectWithValue }) => {
    const token = getState().auth.user?.token
    return await apiSearchJobs(payload, token ?? "", rejectWithValue);
});

export const getPagedJobs = createAsyncThunk<GetJobsListResponse, GetJobsListQuery, {state: RootState, rejectValue: string}>("job/GET_JOBS_LIST", async(payload, { getState, rejectWithValue }) => {
    const token = getState().auth.user?.token
    return await apiGetJobsList(payload, token ?? "", rejectWithValue);
});

export const mergeJobs = createAsyncThunk<MergeJobsResponse, MergeJobsCommand, {state: RootState, rejectValue: string}>("job/MERGE_JOBS", async (payload, { getState, rejectWithValue }) => {
    const token = getState().auth.user?.token
    return await apiMergeJobs(payload, token ?? "", rejectWithValue);
});

export const exportToActTrak = createAsyncThunk<void, ExportJobsCommand, {state: RootState, rejectValue: string}>("job/EXPORT_JOBS", async (payload, { getState, rejectWithValue }) => {
    const token = getState().auth.user?.token
    return await apiExportJobs(payload, token ?? "", rejectWithValue);
});

export const markInvoiced = createAsyncThunk<MarkInvoicedResponse, MarkInvoicedCommand, { state: RootState, rejectValue: string }>("job/MARK_INVOICED", async(payload, { getState, rejectWithValue }) => {
    const token = getState().auth.user?.token;
    return await apiMarkInvoiced(payload, token ?? "", rejectWithValue);
});

export const acknowledgeMerge = createAction("job/ACKNOWLEDGE_MERGE");
export const resetJobPage = createAction("job/RESET_JOB_PAGE");
export const resetJobSlice = createAction("job/RESET_SLICE");
export const resetJobListInvalidation = createAction("job/RESET_JOB_LIST_INVALIDATION");

export const deleteJob = createAsyncThunk<void, number, { state: RootState, rejectValue: string }>("job/DELETE_JOB", async (id, { getState, rejectWithValue }) => {
    const token = getState().auth.user?.token;
    return await apiDeleteJob(id, token ?? "", rejectWithValue);
});

export const renameJob = createAsyncThunk<void, RenameJobCommand, { state: RootState, rejectValue: string }>("job/RENAME_JOB", async (payload, { getState, rejectWithValue }) => {
    const token = getState().auth.user?.token;
    return await apiRenameJob(payload, token ?? "", rejectWithValue);
});